module.exports = __webpack_public_path__ + "img/cns_ios7.abd730dc.png";